import { render, staticRenderFns } from "./ShipmentPrototypeChargesList.vue?vue&type=template&id=a6d01c6e&scoped=true"
import script from "./ShipmentPrototypeChargesList.vue?vue&type=script&lang=js"
export * from "./ShipmentPrototypeChargesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d01c6e",
  null
  
)

export default component.exports